<template>
  <b-row>
    <b-col>
      <b-row class="mb-1">
        <b-col class="text-right">
          <router-link
            :to="{name: 'InternalAnnouncementCreate' }"
            class="btn btn-sm btn-primary">{{$t('buttons.create')}}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
              <div v-if="items.length > 0">
                <table class="table table-striped table-hover">
                  <thead>
                  <tr>
                    <th>{{$t('views.internalannouncement.form.title')}}</th>
                    <th>{{$t('views.internalannouncement.form.internalDescription')}}</th>
                    <th>{{$t('views.internalannouncement.form.dateFromTo')}}</th>
                    <th>{{$t('views.internalannouncement.form.visibleNow')}}</th>
                    <th>{{$t('views.internalannouncement.form.recipientType')}}</th>
                    <th>{{$t('views.internalannouncement.form.published')}}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tr  v-for="item in items"
                        :key="item['@id']">
                    <td>
                      <b-row>
                        <b-col>
                            <router-link :to="{name: 'InternalAnnouncementShow', params: { id: item['@id'] }}">
                              <span>{{item.title}}</span>
                            </router-link>
                        </b-col>
                      </b-row>
                    </td>
                    <td>
                      <b-row>
                        <b-col>
                          <span>{{item.internalDescription}}</span>
                        </b-col>
                      </b-row>
                    </td>
                    <td>
                        <b-row>
                          <b-col>
                            <p class="m-0 p-0">{{$moment(item.dateFrom).format(DATETIMEFORMATTYPE)}}</p>
                            <p class="m-0 p-0">{{$moment(item.dateTo).format(DATETIMEFORMATTYPE)}}</p>
                        </b-col>
                      </b-row>
                    </td>
                    <td>
                      <b-row>
                        <b-col>
<!--                          Jeżeli obecna data jest pomiędzy item.dateFrom a item.dateTo, to wyświetl fa-check-circle-->
                          <i v-if="isAnnouncementActive(item)" style="color: #28a745" class="fa fa-check-circle"></i>
                          <i v-else class="fa fa-times-circle" style="color: #dc3545"></i>
                        </b-col>
                      </b-row>
                    </td>
                    <td>
                      <b-row>
                        <b-col>
                          <span>{{ getRecipientTypeText(item) }}</span>
                        </b-col>
                      </b-row>
                    </td>
                    <td>
                      <i v-if="item.published === 1" style="color: #28a745" class="fa fa-check-circle"></i>
                      <i v-else class="fa fa-times-circle" style="color: #dc3545"></i>
                    </td>
                    <td>
                      <b-dropdown variant="link" size="sm" right text="Right align">
                        <template #button-content>
                          <i class="fa fa-bars fa-lg"></i>
                        </template>
                        <b-dropdown-item @click="publish(item['@id'])"><i class="fa fa-check"></i>{{$t('views.internalannouncement.form.publish')}}</b-dropdown-item>
                        <b-dropdown-item @click="edit(item['@id'])"><i class="fa fa-edit"></i>{{$t('buttons.edit')}}</b-dropdown-item>
                        <b-dropdown-item @click="deleteSingle(item['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.delete')}}</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-else>
                {{$t('notifications.noData')}}
              </div>
              <div v-if="view">
                <pagination
                  :view="view"
                  @getPage="getPage($event)"
                ></pagination>
              </div>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { DATETIMEFORMATTYPE } from '@/config/datetimeFormatType'
import { mapActions, mapGetters } from 'vuex'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'
import remove from '@/utils/remove'
import ApiService from '@/utils/ApiService'
export default {
  components: {
    Loader,
    Pagination
  },
  data () {
    return {
      DATETIMEFORMATTYPE
    }
  },
  computed: mapGetters({
    deletedItem: 'internalannouncement/del/deleted',
    error: 'internalannouncement/list/error',
    items: 'internalannouncement/list/items',
    isLoading: 'internalannouncement/list/isLoading',
    view: 'internalannouncement/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: {
    ...mapActions({
      getPage: 'internalannouncement/list/default'
    }),
    edit (id) {
      this.$router.push({ name: 'InternalAnnouncementUpdate', params: { id: id } })
    },
    getRecipientTypeText (item) {
      return item.recipientType.map(function (recipientText) {
        return this.$t('views.internalannouncement.form.recipientTypeOptions.' + recipientText)
      }.bind(this)).join(', ')
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getPage(this.view['@id'])
      })
    },
    isAnnouncementActive (item) {
      if (this.$moment().isBetween(this.$moment(item.dateFrom), this.$moment(item.dateTo))) {
        return true
      } else {
        return false
      }
    },
    async publish (id) {
      let data = {
        published: 1
      }
      await new ApiService(id + '/publish').put(data)
      this.getPage(this.view['@id'])
    }
  }
}
</script>
